import { render, staticRenderFns } from "./CollectionSlider.vue?vue&type=template&id=04b499b0&"
import script from "./CollectionSlider.vue?vue&type=script&lang=js&"
export * from "./CollectionSlider.vue?vue&type=script&lang=js&"
import style0 from "./CollectionSlider.vue?vue&type=style&index=0&id=04b499b0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports